var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_3814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.44141V9.77141",
    stroke: "#808D9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0204 2C11.1457 1.99969 10.2796 2.17174 9.47138 2.50632C8.66321 2.84091 7.92889 3.33147 7.31039 3.94997C6.69189 4.56847 6.20133 5.30279 5.86675 6.11096C5.53216 6.91913 5.36011 7.78531 5.36043 8.66V10.76C5.32864 11.5583 5.11305 12.3386 4.73043 13.04L3.46323 15.1604C3.2737 15.4409 3.15367 15.7624 3.11306 16.0985C3.07245 16.4346 3.11243 16.7755 3.22969 17.093C3.34695 17.4106 3.53813 17.6956 3.7874 17.9246C4.03668 18.1536 4.3369 18.32 4.66323 18.41C9.44451 20 14.6119 20 19.3932 18.41C19.7087 18.3047 19.9964 18.13 20.2353 17.8986C20.4741 17.6672 20.6579 17.3851 20.7731 17.0732C20.8883 16.7612 20.9319 16.4274 20.9008 16.0963C20.8697 15.7653 20.7645 15.4454 20.5932 15.1604L19.32 13.04C18.9386 12.3381 18.7231 11.5581 18.69 10.76V8.66C18.6799 6.89511 17.9737 5.20553 16.7248 3.95844C15.4759 2.71136 13.7853 2.00756 12.0204 2Z",
    stroke: "#808D9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3299 18.8203C15.3268 19.7025 14.9749 20.5477 14.3511 21.1715C13.7273 21.7953 12.8821 22.1472 11.9999 22.1503C11.1179 22.147 10.2731 21.7945 9.65032 21.1699C9.02576 20.5471 8.67326 19.7023 8.66992 18.8203",
    stroke: "#808D9E",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_3814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.835f8570caa69df0f86280874c4fa0d4.svg";
export { ForwardRef as ReactComponent };